import React from "react";

export const Sidebar = ({ tripTypes, activeId, onSelect }) => {
  return (
    <aside className="w-full lg:w-[300px] shrink-0" data-testid="trip-type-sidebar">
      <p className="text-xs font-bold uppercase tracking-[0.2em] text-slate-400 mb-4">
        1. Vrsta putovanja
      </p>
      <div className="flex flex-col gap-3">
        {tripTypes.map((t) => {
          const Icon = t.icon;
          const active = t.id === activeId;
          return (
            <button
              key={t.id}
              data-testid={`trip-type-${t.id}`}
              onClick={() => onSelect(t)}
              className={`text-left rounded-lg border p-4 flex gap-3 items-start transition-colors duration-200 ${
                active
                  ? "bg-blue-50/80 border-l-[3px] border-blue-600 border-y-blue-100 border-r-blue-100"
                  : "bg-white border-slate-200 hover:bg-slate-100"
              }`}
            >
              <span
                className={`shrink-0 grid place-items-center w-9 h-9 rounded-lg ${
                  active ? "bg-blue-600 text-white" : "bg-slate-100 text-slate-500"
                }`}
              >
                <Icon size={18} strokeWidth={2} />
              </span>
              <span>
                <span
                  className={`block font-semibold leading-tight ${
                    active ? "text-blue-900" : "text-slate-800"
                  }`}
                >
                  {t.title}
                </span>
                <span className="block text-sm text-slate-500 mt-0.5">{t.description}</span>
              </span>
            </button>
          );
        })}
      </div>
    </aside>
  );
};
